const BATCH_POLL_BASE_MS = 2000;
const BATCH_POLL_MAX_MS = 10000;
const DQX_POLL_BASE_MS = 3000;
const DQX_POLL_MAX_MS = 10000;
const DQX_SLOWDOWN_AFTER_ATTEMPTS = 12;

export function nextBatchPollIntervalMs(unchangedStreak: number): number {
  if (unchangedStreak <= 0) {
    return BATCH_POLL_BASE_MS;
  }
  const multiplier = 2 ** Math.min(unchangedStreak, 2);
  return Math.min(BATCH_POLL_BASE_MS * multiplier, BATCH_POLL_MAX_MS);
}

export function nextDqxPollIntervalMs(attempt: number): number {
  if (attempt < DQX_SLOWDOWN_AFTER_ATTEMPTS) {
    return DQX_POLL_BASE_MS;
  }
  if (attempt < DQX_SLOWDOWN_AFTER_ATTEMPTS * 2) {
    return 5000;
  }
  return DQX_POLL_MAX_MS;
}
